var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pet_profile") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_45",
    "data-name": "Layer 45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.84,
    y: 0.29,
    width: 600,
    height: 600,
    fill: "none",
    opacity: 0
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "pet_profile",
    "data-name": "pet profile"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 300.08,
    cy: 299.07,
    r: 300,
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.8,212.1c9-.8,23.54,1,31.85,4.67A102.45,102.45,0,0,1,344,228.14c12.65,9.3,23.66,20.33,33.74,32.3a286.61,286.61,0,0,1,42.44,66.88c5.34,11.85,9.72,24,11.85,36.9a68.61,68.61,0,0,1,.91,14.88,29,29,0,0,1-10.75,21.56,53.64,53.64,0,0,1-27.82,12.2c-11.08,1.55-22.07.54-33-1.39-14.09-2.49-27.76-6.65-41.54-10.37-4.08-1.1-8.22-2-12.32-3a37.1,37.1,0,0,0-19.34.43c-10.09,2.86-20.16,5.79-30.23,8.69-11.91,3.43-23.9,6.49-36.28,7.71-10.54,1-21,.68-31.11-2.75a48.62,48.62,0,0,1-20.79-13.61c-3.89-4.29-5.52-9.56-6.19-15.17-1-8.67.17-17.16,2.15-25.56,3.81-16.24,10.27-31.48,18-46.21a282.31,282.31,0,0,1,45.86-64.74c9.13-9.56,19-18.25,30.4-25.09,7.27-4.36,14.93-7.79,23.4-9.07a53.53,53.53,0,0,1,6.57-.52A27.58,27.58,0,0,1,292.8,212.1Z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,125.31a93,93,0,0,1-4.57,27.8,109.8,109.8,0,0,1-15.63,31.78A51.54,51.54,0,0,1,373,197.83c-10.32,7-21.31,7.81-32.71,3-9-3.77-15.88-10.19-21.38-18.14a69.64,69.64,0,0,1-12.77-40.19c-.05-16.9,6.27-31.34,17.58-43.7a76.36,76.36,0,0,1,27-19.32,46.07,46.07,0,0,1,17.43-3.87c12.11-.14,21.4,5.11,28.3,14.78,6,8.35,8.44,17.93,9.33,28,.1,1.14.17,2.29.19,3.43S405.94,124.16,405.94,125.31Z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.29,127.21c.19-12.55,1.92-22.59,7.14-31.77s12.66-15.56,23.23-17.63a38.71,38.71,0,0,1,21.22,1.86c20.51,7.68,35.72,21.18,44.33,41.48,4.73,11.16,5.47,22.9,3.33,34.8a68.69,68.69,0,0,1-16,33.88c-5.75,6.55-12.63,11.5-21.15,13.87-10.92,3-20.86.92-29.81-5.9-7.24-5.52-12.51-12.75-17-20.52a109.88,109.88,0,0,1-14.09-38.79C184.77,134.06,184.53,129.57,184.29,127.21Z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.78,237.2c-.14,9.92-2.45,19.23-8.31,27.38-8.42,11.69-21.67,17.36-37.6,12.93a77.77,77.77,0,0,1-24.6-12.27c-8-5.8-15.05-12.64-20.25-21.16-4.81-7.86-7.84-16.3-7.45-25.65.49-11.64,5.81-20.46,15.91-26.37A46.54,46.54,0,0,1,140,186.2c12.58-1.17,24.75.5,36.16,6.13,13.47,6.64,21.76,17.49,25.14,32,1,4.18,1.28,8.51,1.9,12.77Z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.86,182.66c8,.31,16.13,1.46,23.58,5.5,11.23,6.1,16.82,15.59,16.95,28.27.1,9.53-3.07,18.16-8.3,25.94a81,81,0,0,1-41.57,31.8,34,34,0,0,1-20.17,1.21,33.31,33.31,0,0,1-22.54-18.94c-8.72-18.95-7.1-37.26,5.28-54.18,6.11-8.35,14.85-13.24,24.6-16.35A75.27,75.27,0,0,1,448.86,182.66Z",
    fill: "#bfebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.43,524.45a46.29,46.29,0,0,1-25.31-7.52l-82.83-53.85a88.21,88.21,0,0,1-18.86,6.3,89.22,89.22,0,0,1-18.33,1.92,88,88,0,1,1,88-86.08L399.81,439a46.5,46.5,0,0,1-25.38,85.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.25,310.31A73,73,0,0,1,301.53,393l90.1,58.58a31.5,31.5,0,0,1,9.24,43.58h0a31.5,31.5,0,0,1-43.58,9.24l-90.23-58.67a73,73,0,1,1-37.81-135.38m0-30a103.85,103.85,0,0,0-21.43,2.25A103,103,0,1,0,264.73,480l76.21,49.55a61.5,61.5,0,1,0,67-103.12L332,377a102.11,102.11,0,0,0-2.05-15,103,103,0,0,0-100.67-81.64Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,416.32a33.2,33.2,0,1,1,33.2-33.2A33.25,33.25,0,0,1,228.59,416.32Z",
    fill: "#00a0df"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.59,350.05a33.07,33.07,0,1,1-33.07,33.07,33.07,33.07,0,0,1,33.07-33.07m0-.25a33.32,33.32,0,1,0,33.33,33.32,33.35,33.35,0,0,0-33.33-33.32Z",
    fill: "#00a0df"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetProfile);
export default __webpack_public_path__ + "static/media/pet_profile.d980e9b70478f4ff81f3ca9ea99601d6.svg";
export { ForwardRef as ReactComponent };